<script>
import gql from "graphql-tag";
import { tournamentMatchFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";

export default {
  name: "GenerateKODrawDialog",
  extends: BaseDialog,
  props: { tournament: Object },
  data: function() {
    return {
      nConsolationFlights: {
        label: "Number of conselation flights",
        type: DialogInputTypes.number,
        value: 3,
        hint: "Up to 3 conselation flights are supported"
      },
      nSeeds: {
        label: "Number of seeds",
        hint: "The number of highest-ranked players to seed",
        value: 4,
        type: DialogInputTypes.number
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.nConsolationFlights, this.nSeeds];
      }
    },
    title: {
      get() {
        return "Generate KO Draw";
      }
    },
    instructions: {
      get() {
        return "Generate a traditional binary-tree format with consolations flights to potentially give competitors a second or even a third chance at winning a flight.  Byes will count as matches played.";
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation(
              $tournamentId: ID!
              $knockoutOptions: KnockoutFormatOptions!
            ) {
              generateKnockoutDraw(
                tournamentId: $tournamentId
                knockoutOptions: $knockoutOptions
              ) {
                ...TournamentMatch
              }
            }
            ${tournamentMatchFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            knockoutOptions: {
              numberOfConselationFlights: this.nConsolationFlights.value,
              seeds: this.nSeeds.value
            }
          }
        })
        .then(result => {
          this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit("setNotification", `Generated KO draw`);
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to generate KO draw");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// generateKODrawDialog.vue?046035d5